module.exports = __webpack_public_path__ + "media/public/img/landing_page/GettinLocal-2-f4115f9e66b022a636945eeb501d5bc3.jpg";